import OverviewTab from "./tabs/overview/OverviewTab"
import ManageRolesTab from "./tabs/manage_roles/ManageRolesTab"
import TimesAndLocationsTab from "./tabs/times_and_locations/TimesAndLocationsTab"
import AuditionsTab from "./tabs/auditions/AuditionsTab"
import RecallsTab from "./tabs/recalls/RecallsTab"
import CastingChoicesTab from "./tabs/casting_choices/CastingChoicesTab"
import { CalendarMonth, Diversity3, DoorFront, MeetingRoom, ReduceCapacity, Tune } from "@mui/icons-material"

/**
 * The consoleRouter returns the mapping of console tabs to components
 */

let consoleRouter = {

  overview: 
  {
    title: 'Overview',
    icon: <Tune />,
    element: <OverviewTab />,
    separatorAfter: true
  },

  roles: 
  {
    title: 'Roles',
    icon: <Diversity3 />,
    element: <ManageRolesTab />
  },

  times: 
  {
    title: 'Times & Locations',
    icon: <CalendarMonth />,
    element: <TimesAndLocationsTab />,
    separatorAfter: true
  },

  auditions: 
  {
    title: 'Auditions',
    icon: <MeetingRoom />,
    element: <AuditionsTab />
  },

  recalls: 
  {
    title: 'Recalls',
    icon: <DoorFront />,
    element: <RecallsTab />
  },

  casting: 
  {
    title: 'Casting Choices',
    icon: <ReduceCapacity />,
    element: <CastingChoicesTab />
  },

}


export default consoleRouter